// @ts-nocheck
import { userSetupSettingsStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupSettings";
import { userSettupProps } from "@store/Themes/common/props/userSetup";

Object.assign(userSetupSettingsStyles, {
    title: userSettupProps.title,
});
